<template>
  <div class="Input">
    <span class="label" :style="{ width: labelWidth || '80px' }" v-if="label">{{
      label
    }}</span>
    <div class="input_box">
      <div class="input_boxcross">
        <input
          v-model="col"
          :placeholder="placeholder"
          :type="type"
          v-bind="$attrs"
          :readonly="readonly"
          @input="
            (e) => {
              handleinput(e);
            }
          "
          :disabled="disabled"
          :maxlength="maxlength"
          ref="Field"
        />

        <span class="amountCompany">{{ amountCompany }}</span>
        <van-icon
          v-show="isDelete"
          @click="clickDelete"
          class="cross"
          name="cross"
        />
      </div>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Input',
  props: [
    'props',
    'placeholder',
    'reg',
    'maxlength',
    'type',
    'disabled',
    'value',
    'label',
    'labelWidth',
    'border',
    'prop',
    'separate',
    'readonly',
    'toUpperCase',
    'amountCompany',
  ],
  data() {
    return {
      col: '',
      errorMessage: '',
      isDelete: false,
    };
  },
  watch: {
    readonly: {
      handler(val) {
        // eslint-disable-next-line no-unused-expressions
        !val ? (this.isDelete = false) : '';
      },
      immediate: true,
    },
    col: {
      handler(newVal, oldVal) {
        if (oldVal === undefined) {
          this.col = this.value;
        }
        if (newVal !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.readonly ? (this.isDelete = true) : '';
        } else {
          this.isDelete = false;
        }
        this.$emit('input', newVal);
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.col = this.setSeparate(val);
        this.$emit('input', this.setSeparate(val));
      },
      immediate: true,
    },
  },
  methods: {
    setSeparate(val) {
      if (this.separate) {
        let value = val.replace(/\D/g, '').substr(0, 11); // 不允许输入非数字字符，超过11位数字截取前11位
        const len = value.length;
        if (len > 3 && len < 8) {
          value = value.replace(/^(\d{3})/g, '$1 ');
        } else if (len >= 8) {
          value = value.replace(/^(\d{3})(\d{4})/g, '$1 $2 ');
        }
        return value;
      } if (this.toUpperCase) {
        return val.toUpperCase();
      }
      return val;
    },
    handleinput() {
      const { inputVal } = this.amountRuleJudgment(this.col);
      this.col = inputVal;
      this.$emit('input', inputVal);
    },
    // 金额规则判断
    amountRuleJudgment(col) {
      // 正整数
      const inputVal = JSON.parse(JSON.stringify(col)).replace(/^([A-Za-z0-9\u4e00-\u9fa5])+/, '$1');
      console.log(inputVal);
      return {
        inputVal,
      };
    },
    clickDelete() {
      this.col = '';
    },
  },
};
</script>
<style scoped>
.Input {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  position: relative;
}
input {
  width: 70%;
  border: 0;
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  display: flex;
  align-items: center;
}
.error-message {
  color: #ee0a24;
  font-size: 12px;
  text-align: left;
}
.input_box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.input_boxcross > input:disabled {
  color: #495060;
  -webkit-text-fill-color: #495060;
  -webkit-opacity: 1;
  opacity: 1;
}
.cross {
  color: #9e9fa0;
}
input::-webkit-input-placeholder {
  color: #d8d8da;
}
input::-moz-input-placeholder {
  color: #d8d8da;
}
input::-ms-input-placeholder {
  color: #d8d8da;
}
input:disabled {
  background-color: #fff !important;
}
.amountCompany {
  font-size: 14px;
  color: #1c2438;
}
</style>
